export default from './report-post-modal';



// WEBPACK FOOTER //
// ./app/containers/report-post-modal/index.js